<template>
<div class="bto-sb-widget bto-sb-widget-prematch  bto-sb-widget-horse-period"
    :class=" this.date === hrTimeFilters.ANTE_POST ? 'bto-sb-widget-horse-antepost' : 'bto-sb-widget-prematch-full-view'">
    <div class="bto-sb-widget-title">
      <h3>{{ t('HR.All') }}</h3>
    </div>
    <div class="bto-sb-widget-content">
      <div class="bto-sb-event-sports">
          <ul>
            <li v-if="horseRacingTab" :class="[{'bto-sb-event-sports-active': selectedSport === horseRacingSportId}]" @click="changeSport(horseRacingSportId)"><span class="bto-sb-sports-icon horseracing"></span><a>{{t('PUBLIC.HORSERACING')}}</a></li>
            <li v-if="greyhoundRacingTab" :class="[{'bto-sb-event-sports-active': selectedSport === greyhoundRacingSportId}]" @click="changeSport(greyhoundRacingSportId)"><span class="bto-sb-sports-icon greyhoundracing"></span><a>{{ t('GR.GreyhoundsRacing') }}</a></li>
          </ul>
      </div>
      <div class="bto-sb-event-sports bto-sb-event-sports-noicon">
        <ul>
          <li @click="selectDate(hrTimeFilters.TODAY)" :class="{'bto-sb-event-sports-active':this.date === hrTimeFilters.TODAY}">
            <a>{{t('Public.Today')}}</a>
          </li>
          <li @click="selectDate(hrTimeFilters.TOMORROW)" :class="{'bto-sb-event-sports-active':this.date === hrTimeFilters.TOMORROW}">
            <a>{{t('Mobile.Tomorrow')}}</a>
          </li>
          <!-- <li @click="selectDate(hrTimeFilters.ANTE_POST)" :class="{'bto-sb-event-sports-active':this.date === hrTimeFilters.ANTE_POST}">
            <a>{{t('HR.AntePost')}}</a>
          </li> -->
          <!-- <li @click="selectDate(hrTimeFilters.RESULTS)" :class="{'bto-sb-event-sports-active':this.date === hrTimeFilters.RESULTS}">
            <a>{{t('HR.ResultsYesterday')}}</a>
          </li> -->
        </ul>
        <div class="bto-sb-horse-event-status" v-if="date === hrTimeFilters.TODAY">
          <span class="bto-sb-horse-status-results">{{t('BetSlip.Results')}}</span>
          <span class="bto-sb-horse-status-running">{{t('HR.Running')}}</span>
          <span class="bto-sb-horse-status-soon">{{t('HR.StartingSoon')}}</span>
        </div>
      </div>
      <empty-state v-if="HRraces.length === 0 || this.loading === true" 
        :message="t(loading ? 'Mobile.LoadingMore' : 'HR.NoEvents')" 
        :hideShadow="loading ? true : false"
        :icon-class="loading ? loadingSpinner : eptyStateIcon" />
      <today-races-hr v-if="date !== hrTimeFilters.ANTE_POST && this.loading === false" :HRraces="HRraces" @openDetails="openDetails"/>
      <antepost-races v-if="date === hrTimeFilters.ANTE_POST && this.loading === false"  :HRraces="HRraces" @openDetails="openDetails" />
    </div>
</div>
</template>

<script>
  import HRtimeRequestService from './hr-time-filer-request';
  import HRMatchModel from '../category-horse-racing/hr-match-model';
  import { HORSE_RACING_TIME_FILTERS } from '../../../models/enums/horse-racing-const';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import AntepostRaces from './antepost-races';
  import TodayRacesHr from './today-races';
  import store from '../../../store';

  export default {
    name: "ScheduleRacesWidgetHr",
    components: {
      EmptyState,
      AntepostRaces,
      TodayRacesHr
    },
    data() {
      return {
        HRraces: [],
        date: 100,
        loading: false,
        hrTimeFilters: HORSE_RACING_TIME_FILTERS,
        apiInterval: null,
        selectedSport: null,
        loadingSpinner: ICON_CLASS.LOADING,
      };
    },
    props: {
      horseRacingTab: {
        type: Boolean,
        default: true,
        label: 'Show horse racing tab',
      },
      greyhoundRacingTab: {
        type: Boolean,
        default: true,
        label: 'Show greyhound racing tab',
      },
    },
    computed: {
      horseRacingSportId() {
        return store.state.SportsModule.hrSportId;
      },
      greyhoundRacingSportId() {
        return store.state.SportsModule.ghSportId;
      },
      eptyStateIcon() {
        if (this.selectedSport === this.horseRacingSportId) {
          return ICON_CLASS.HORSE;
        }
        return ICON_CLASS.GREYHOUND;
      },
    },
    watch: {
      horseRacingSportId: {
        handler(val) {
          if (val && this.HRraces.length === 0) {
            this.selectedSport = this.getSelectedSport();
            this.getHRRaces(this.date);
          }
        },
        immediate: true,
      },
    },
    mounted() {
      this.setApiInterval();
    },
    destroyed() {
      this.clearApiInterval();
    },
    methods: {
      getSelectedSport() {
        if (this.horseRacingTab) {
          return this.horseRacingSportId;
        } else if (!this.horseRacingTab && this.greyhoundRacingTab) {
          return this.greyhoundRacingSportId;
        } else {
          return this.greyhoundRacingSportId;
        }
      },
      changeSport(id) {
        this.selectedSport = id;
        this.getHRRaces(this.date);
      },
      setApiInterval() {
        this.clearApiInterval();
        if (parseInt(this.date, 10) !== this.hrTimeFilters.RESULTS) {
          this.apiInterval = setInterval(() => {
            this.getHRRaces(this.date, false);
          }, 30000);
        }
      },
      clearApiInterval() {
        clearInterval(this.apiInterval);
      },
      getHRRaces(date, showLoading = true) {
        const tournamentMatchesRequest = new HRtimeRequestService(date, [this.selectedSport]);
        this.loading = showLoading ? true : false;
        tournamentMatchesRequest.execute((response) => {
          let data = response.data.map(a => new HRMatchModel(a));
          if (!showLoading && response.data.length === 0) {
            this.HRraces = [];
          }
          let sortByCategory = this.sortByTournament(data);
          this.HRraces = date === HORSE_RACING_TIME_FILTERS.ANTE_POST ? this.sortByCategory(data) : this.sortByCategory(sortByCategory);
        }).finally(() => {
          this.loading = false;
        });
      },
      selectDate(date) {
        this.date = date;
        this.getHRRaces(this.date);
        if (this.date !== this.hrTimeFilters.RESULTS) {
          this.setApiInterval();
        } else {
          this.clearApiInterval();
        }
      },
      openDetails(tournamentId, number) {
        this.$router.push({ name: 'raceDetailsHr', params: { sportId: this.selectedSport, raceId: `${tournamentId}`, raceDateFilter: this.date }, query: { rnum: number } });
      },
      sortByTournament(matches) {
        return matches.reduce((acc, cur) => {
          const newMatchObject = () => {
            acc[acc.length] = {
              tournamentId: cur.tournamentId,
              categoryId: cur.categoryId,
              tournaments: [cur],
              tournamentName: cur.tournamentName,
              categoryName: cur.categoryName,
              categoryCss: cur.categoryCss,
            };
          };
          if (acc.length > 0) {
            const isCategory = acc.findIndex(item => (item.categoryId === cur.categoryId) && (item.tournamentId === cur.tournamentId));
            if (isCategory > -1) {
              acc[isCategory].tournaments.push(cur);
            } else {
              newMatchObject();
            }
          } else {
            newMatchObject();
          }
          return acc;
        }, []);
      },
      sortByCategory(matches) {
        return matches.reduce((acc, cur) => {
          const newMatchObject = () => {
            acc[acc.length] = {
              categoryId: cur.categoryId,
              categories: [cur],
              categoryName: cur.categoryName,
              categoryCss: cur.categoryCss,
            };
          };
          if (acc.length > 0) {
            const isCategory = acc.findIndex(item => (item.categoryId === cur.categoryId));
            if (isCategory > -1) {
              acc[isCategory].categories.push(cur);
            } else {
              newMatchObject();
            }
          } else {
            newMatchObject();
          }
          return acc;
        }, []);
      }
    }
  };
</script>

